import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAuth } from 'lib/auth';
import { APP_VIEW, ORDER_LIST_VIEW, PRODUCT_LIST_VIEW } from 'routes/urls';
import { EXTERNAL_ADMIN_SCOPE } from 'utils/const';

import { Layout } from '../components/Layout';
import { LoginForm } from '../components/LoginForm';

export const Login = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleLoginSuccess = () => {
    // user はレンダリング時点の値のため、直後のログインで更新された localStorage も参照する
    const scope = user?.externalAdminScope || localStorage.getItem('externalAdminScope') || null;

    if (scope === EXTERNAL_ADMIN_SCOPE.ORDERS || scope === EXTERNAL_ADMIN_SCOPE.BUYER) {
      navigate(ORDER_LIST_VIEW);

      return;
    }

    navigate(scope === EXTERNAL_ADMIN_SCOPE.PRODUCTS ? PRODUCT_LIST_VIEW : APP_VIEW);
  };

  return (
    <Layout>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          alignSelf: 'center',
        }}
      >
        <LoginForm onSuccess={handleLoginSuccess} />
      </Box>
    </Layout>
  );
};
